import { registerPlugin } from "@capacitor/core";
export const GigSyncTranslate = registerPlugin("GigSyncTranslate", {
    web: () => import("./web.js").then((m) => new m.GigSyncTranslateWeb()),
});
export * from "./definitions.js";
//# sourceMappingURL=index.js.map